import React, { CSSProperties } from 'react';
import { ReadOnlyIdView, ReadOnlyTitleView, ButtonView, ReadOnlyTextView, ReadOnlyNumberView } from '@vivli/shared/views';
import { cardContainerStyle, upperSectionStyle, lowerSectionStyle } from './card-styles';
import { IDisclosureActionDetailDto } from '@vivli/features/dashboard/infrastructure/interface';
import { Color } from '@vivli/shared/theme';

interface DisclosureActionCardViewProps {
    dto: IDisclosureActionDetailDto;
}

export const upperSectionStyleWideFirst: CSSProperties = {
    ...upperSectionStyle,
    gridTemplateColumns: '220px 1fr auto',
};

export const lowerSectionStyleWideFirst: CSSProperties = {
    ...lowerSectionStyle,
    gridTemplateColumns: '220px 1fr 1fr 1fr',
};

export const DisclosureActionCardView = ({ dto }: DisclosureActionCardViewProps) => {
    const handleDisclosureActionDestination = () => {
        const destination = `disclosure/${dto?.dataRequestId}/${dto.uniqueId}`;

        window.open(destination, '_blank');
    };

    return (
        <div style={cardContainerStyle}>
            <div style={upperSectionStyleWideFirst}>
                <ReadOnlyIdView idContent={dto.vivliId} idHeader={'ID'}></ReadOnlyIdView>
                <ReadOnlyTitleView titleContent={dto.title} titleHeader={'Disclosure Title'}></ReadOnlyTitleView>
                <div style={{ justifySelf: 'end' }}>
                    <ButtonView title={dto.actionText} theme={'white-on-lightblue'} onClick={handleDisclosureActionDestination}>
                        {dto.actionText}
                    </ButtonView>
                </div>
            </div>
            <div style={lowerSectionStyleWideFirst}>
                <div> </div>
                <ReadOnlyTextView
                    textContent={`${dto.leadInvestigatorFirstName} ${dto.leadInvestigatorLastName}`}
                    textHeader={'Lead Investigator'}
                ></ReadOnlyTextView>
                <ReadOnlyNumberView
                    numberContent={`${dto.daysLeft} ${dto.daysLeft === 1 ? 'Day' : 'Days'} Left`}
                    numberHeader={'30-Day Review'}
                    useWarningColors={true}
                    warningOn={dto.daysWarning}
                ></ReadOnlyNumberView>
                <ReadOnlyTextView textContent={dto.disclosureType} textHeader={'Disclosure Type'}></ReadOnlyTextView>
            </div>
        </div>
    );
};
